import {useQuery} from '@tanstack/react-query';
import { authorizedGet } from '../functions/AuthService';

export const useProcesses = () => {
    return useQuery({
        queryKey: ['process', 'activeOps'],
        queryFn: async () => {
            const response = await authorizedGet("/process/getdata");
            const resData = await response.body.json();
            // console.log("Data: ", resData);
            
            return resData;
        },
        staleTime: 1000 * 60 * 5, //5 minutes
        gcTime: 1000 * 60 * 120, //Keep it in memory for 2 hours
        refetchOnWindowFocus: false //Prevent refresh if the tab is clicked
    });
}